import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { StyledTab, StyleTabPanel, StyleTabsContainer } from './StyledComponents'
import { ITabList, ITabPanelProps } from './types'

function TabPanel(props: ITabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <StyleTabPanel sx={{ p: 3 }}>{children}</StyleTabPanel>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const TabList: React.FC<ITabList> = ({ lists, currentTab }) => {
  const [value, setValue] = useState(0)

  useEffect(() => {
    setValue(currentTab || 0)
  }, [currentTab])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <StyleTabsContainer
        value={value}
        onChange={handleChange}
        aria-label='basic tabs example'
        indicatorColor={undefined}
      >
        {lists.map((list, index) => (
          <StyledTab
            key={`${list.label}-${index}`}
            label={list.label}
            disabled={list.disabled}
            {...a11yProps(index)}
          />
        ))}
      </StyleTabsContainer>
      {lists.map((list, index) => (
        <TabPanel key={`${list.label}-${index}`} value={value} index={index}>
          {list.component}
        </TabPanel>
      ))}
    </Box>
  )
}

export default TabList
